import { Box, Flex, Heading, Text } from "@chakra-ui/react";
import { createColumnHelper } from "@tanstack/react-table";
import { useApi } from "hooks/useApi";
import { useCache } from "hooks/useCache";
import { useMemo, useState } from "react";
import DashboardTable from "../DashboardTable";

type Table3RowType = {
  id: string;
  name: string;
  sub_area_name: string;
  last_activity: string;
  total_collected: any;
  tax_payment_status: string;
  number_of_scans: number;
  last_scan_time: string;
};

export default function TaxCollectorsTable(props:any) {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [searchBarValue34, setSearchBarValue34] = useState("");
  const { getTaxCollectors } = useApi();
    const { data: taxCollectors, mutate } = useCache("getTaxCollectors", () =>
      getTaxCollectors(page, searchBarValue34, 5, "active")
    );
    const handleSearch = (event: any) => {
      // const value = event.target.value;
      // setSearchBarValue34(value);
      mutate(getTaxCollectors(page, searchBarValue34, 5));
    };
    const handleClearSearch = (event: any) => {
      setSearchBarValue34("");
      mutate(getTaxCollectors(page, ""));
    };
  
    const handleJumpToPage = (pg: number) => {
      setPage(pg);
      mutate(getTaxCollectors(pg));
    };
    const handleSetNextPage = () => {
      if (taxCollectors?.length > 0 && taxCollectors[0].num_of_pages >= page + 1) {
        setPage((prev: any) => prev + 1);
        mutate(getTaxCollectors(page + 1));
      }
    };
    const handleSetPrevPage = () => {
      if (taxCollectors?.length > 0 && page > 0) {
        setPage((prev: any) => prev - 1);
        mutate(getTaxCollectors(page + 1));
      }
    };
  const table3Columns = useMemo(() => {
    const table3ColumnHelper = createColumnHelper<Table3RowType>();
    return [
          table3ColumnHelper.accessor("name", {
            cell: (info) => (
              <Box flex={1}>
                <Flex gap="8px" alignItems="center" px="12px" py="0px">
                  <Text style={{ textTransform: "capitalize" }}>
                    {info.getValue<string>()}
                  </Text>
                </Flex>
              </Box>
            ),
            header: (info) => (
              <Flex flex={1} px={"25px"} py="14px">
                <Heading as="h6">Nom</Heading>
              </Flex>
            ),
            meta: { width: "100px" },
          }),
          table3ColumnHelper.accessor("sub_area_name", {
            cell: (info) => (
              <Box flex={1}>
                <Flex gap="8px" alignItems="center" px="12px" py="0px">
                  <Text style={{ textTransform: "capitalize" }}>
                    {info.getValue<string>()}
                  </Text>
                </Flex>
              </Box>
            ),
            header: (info) => (
              <Flex flex={1} px={"25px"} py="14px">
                <Heading as="h6">Zone</Heading>
              </Flex>
            ),
            meta: { width: "120px" },
          }),
          table3ColumnHelper.accessor("last_scan_time", {
            cell: (info) => (
              <Flex px={{ base: "20px", sm: "24px" }}>
                <Text>
                  {info.getValue<string>()}
                </Text>
              </Flex>
            ),
            header: (info) => (
              <Flex p="14px" px={"40px"}>
                <Heading as="h6">Dernier scan</Heading>
              </Flex>
            ),
            meta: { width: "160px" },
          }),
          table3ColumnHelper.accessor("number_of_scans", {
            cell: (info) => (
              <Flex px={{ base: "20px", sm: "24px" }}>
                <Text>{info.getValue<string>()}</Text>
              </Flex>
            ),
            header: (info) => (
              <Flex p="14px" px={"40px"} overflow={"hidden"}>
                <Heading as="h6">Nbre de scans</Heading>
              </Flex>
            ),
            meta: { width: "200px" },
          }),
          table3ColumnHelper.accessor("total_collected", {
            cell: (info) => (
              <Box flex={1}>
                <Flex
                  gap="8px"
                  alignItems="center"
                  px="12px"
                  py="0px"
                  justifyContent={"flex-end"}
                >
                  <Text style={{ textTransform: "capitalize" }}>
                    {info.getValue<string>() || 0} FCFA
                  </Text>
                </Flex>
              </Box>
            ),
            header: (info) => (
              <Flex flex={1} px={"25px"} py="14px" justifyContent={"flex-end"}>
                <Heading as="h6">Montant collecté</Heading>
              </Flex>
            ),
            meta: { width: "120px" },
          }),
        ];
  }, []);
  return (
    <>
      <DashboardTable
        title="Activité des collecteurs"
        pageSize={pageSize}
        setPageSize={setPageSize}
        page={page}
        handleJumpToPage={handleJumpToPage}
        handleSearch={handleSearch}
        handleSetNextPage={handleSetNextPage}
        handleSetPrevPage={handleSetPrevPage}
        handleClearSearch={handleClearSearch}
        tableColumns={table3Columns}
        tableData={taxCollectors}
        searchKey={searchBarValue34}
        setSearchKey={setSearchBarValue34}
      />
    </>
  );
}
